export default __webpack_public_path__ + "static/education-ferris-wheel-91ceadcbc7e2c3a14e1cb452fa48ebbb.gif";